export function keySort(keys, reverse) {
    return (a, b) => {

        for (let key of keys) {
            if (a[key] == b[key]) {
                continue
            }
            if (a[key] < b[key]) {
                return reverse ? 1 : -1
            } else {
                return reverse ? -1: 1
            }
        }

        return 0;
    }
}

export function sortHML(column) {
    let keyMap = {
        "High": 3,
        "Medium": 2,
        "Low": 1
    }

    return (a, b, desc) => {
        // handle ORM items
        if (a.details) {
            a = a.details;
            b = b.details;
        }

        a = keyMap[a[column]] || 0;
        b = keyMap[b[column]] || 0;
        if (a > b) {
            return desc ? -1: 1;
        }
        if (b > a) {
            return desc ? 1: -1;
        }
        return 0;
    }
}


export function downloadFile(content, filename, contentType="text/plain") {
    let file = new Blob([content], {type: contentType});

    let url = URL.createObjectURL(file);
    let link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_new";

    link.click();

    URL.revokeObjectURL(url);
}